import React from 'react';
import img from './ExternalLink.svg';

const External = props => <img {...props} src={img} alt="external link" />;

export default External;
